const sum = (a, b, fractionDigit = 2) =>
  parseFloat((parseFloat(a) + parseFloat(b)).toFixed(fractionDigit))

const subtract = (a, b, fractionDigit = 2) =>
  parseFloat((parseFloat(a) - parseFloat(b)).toFixed(fractionDigit))

const equal = (a, b) => parseFloat(a) === parseFloat(b)

export default { sum, subtract, equal }
